var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"releases-placeholder"},_vm._l((3),function(n){return _c('div',{key:n,staticClass:"release"},[_c('div',{staticClass:"release-info"},[_c('button',{staticClass:"link info small",attrs:{"disabled":""}}),_vm._v(" "),_c('placeholder',{attrs:{"lines":2}})],1),_vm._v(" "),_c('placeholder',{attrs:{"lines":3}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e13fa07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Releases/ReleasesPlaceholder.vue
// module id = null
// module chunks = 